<template>
  <div class="balance-page">
    <TopTitle title="财务管理" />

    <div class="home-page-tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="余额充值" name="first">
          <div class="balance-div">
            <div class="top-div">
              <div class="flex top-info">
                <div class="top-info-div">
                  <div class="text-left">账户余额：</div>
                  <div class="weight-text">{{ (companyInfo && companyInfo.amount) ? companyInfo.amount : 0 }}<span class="span-text">U币</span></div>
                </div>
                <div class="top-info-div">
                  <div class="text-left">可用积分：</div>
                  <div class="weight-text">{{ (companyInfo && companyInfo.points) ? companyInfo.points : 0 }}<span class="span-text">分</span></div>
                </div>
                <!-- <div class="top-info-div">
                  <div class="text-left">账户状态：</div>
                  <div class="weight-text">{{ (companyInfo && companyInfo.enable) == 1 ? '启用' : '禁用' }}</div>
                </div> -->
              </div>
            </div>
            <div class="desc-text">温馨提示：U币是货代平台的价值流通币，可代替人民币进行支付</div>

            <div class="tab-div flex">
              <div class="cursor-pointer" :class="tabType == 1 ? 'blue' : 'black'" @click="tabClick(1)">微信/支付宝/银联</div>
              <div class="cursor-pointer" :class="tabType != 1 ? 'blue' : 'black'" @click="tabClick(2)">对公转账</div>
            </div>
            <div class="bottom-div" :style="tabType == 1 ? 'height: 542px;' : 'height: 420px;'">

              <div class="pay-price" v-if="tabType == 1">
                <div class="price-box content-center" :class="active == 30 ? 'price-active' : ''" @click="choosePrice(30)">¥ 30</div>
                <div class="price-box content-center" :class="active == 100 ? 'price-active' : ''" @click="choosePrice(100)">¥ 100</div>
                <div class="price-box content-center" :class="active == 500 ? 'price-active' : ''" @click="choosePrice(500)">¥ 500</div>
                <div>
                  <div class="other-text">输入其他金额</div>
                  <div class="flex">
                    <div class="price-logo content-center">¥</div>
                    <div>
                      <el-input v-model="otherPrice" :maxlength="13" @input="changePrice" placeholder="请输入金额" />
                    </div>
                  </div>
                </div>
              </div>

              <table border="1" cellspacing="0" v-if="tabType == 1">
                <tr>
                  <th>充值帐号</th>
                  <td>{{ userInfo.phone }}</td>
                </tr>
                <tr>
                  <th style="border-bottom: none;">到账账户</th>
                  <td style="border-bottom: none;">{{ userInfo.companyName }}</td>
                </tr>
              </table>
              <table border="1" cellspacing="0" v-else>
                <tr>
                  <th>账户名称</th>
                  <td>杭州未斯科技有限公司</td>
                </tr>
                <tr>
                  <th>对公账户</th>
                  <td>1202 2209 1910 0199 712</td>
                </tr>
                <tr>
                  <th>开户银行</th>
                  <td>中国工商银行杭州余杭支行</td>
                </tr>
                <tr>
                  <th style="border-bottom: none;">转账备注</th>
                  <td style="border-bottom: none;">客户公司名：{{ userInfo.companyName }}</td>
                </tr>
              </table>
              <div class="agree-div content-left" v-if="tabType == 1">
                <div class="content-between" style="width: 922px">
                  <div class="content-center">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <div @click="agree" class="agree-text cursor-pointer" style="margin: 0 8px;">同意</div>
                    <div class="agree-text cursor-pointer hover" style="color: #1170eb;" @click="serviceAgreementDialogVisible = true">未斯科技充值用户条例</div>
                  </div>
                  <div class="content-center">
                    <div class="pay-div content-right" v-if="tabType == 1">
                      <div class="txt">实付金额：</div>
                      <div class="price">¥ {{ otherPrice ? otherPrice : active }}</div>
                      <el-button type="primary" class="pay-btn content-center" @click="toPay">确认支付</el-button>
                    </div>
                  </div>
                </div>

              </div>
              <!-- <div class="desc-text" style="width: 876px;" v-if="tabType == 1">温馨提示：单次充值金额 不得少于30元 且 不得超过100000元，充值金额支持开具发票。充值支持对公打款转账，转账时请备注：猿航U币充值。详情请 <span onclick="window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true');" class="cursor-pointer" style="text-decoration: underline;">联系我们</span></div> -->
              <div class="desc-text" style="width: 922px;margin-top: 24px;background: #EAF1FA;">温馨提示：充值金额支持开具发票！充值支持对公转账，转账时请备注：{{ userInfo.companyName }}。如有疑问请 <span onclick="window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true');" class="cursor-pointer hover" style="color:#1170eb;">联系我们</span></div>

            </div>

          </div>

        </el-tab-pane>
        <!-- <el-tab-pane label="充值记录" name="second">
          <RecordList v-if="activeName == 'second' " />
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <ServiceAgreement v-if="serviceAgreementDialogVisible" :visible.sync="serviceAgreementDialogVisible" type="pay" />
    <PayQrCode v-if="visible" :visible="visible" :payPrice="otherPrice ? otherPrice : active" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import TopTitle from '@/components/TopTitle'
import ServiceAgreement from '@/components/ServiceAgreement'
import PayQrCode from './components/PayQrCode'
// import RecordList from "./recordList.vue"
import { httpAjax } from '@/api/ajax'


export default {
  name: 'Balance',
  components: {
    TopTitle,
    PayQrCode,
    ServiceAgreement
    // RecordList
  },
  data () {
    return {
      companyInfo: {}, // 账户信息
      userInfo: {}, // 用户信息
      otherPrice: '', // 其他金额
      serviceAgreementDialogVisible: false,


      tabType: 1,
      checked: false,
      active: 0,
      visible: false,

      activeName: 'first',
      msgActive: true,
      multipleSelection: [],
      tableData: [11]

    }
  },
  created () { 
    this.getCompanyMsg()
    this.getUserMsg()
  },
  methods: {
    // 
    changePrice(){
      console.log(this.otherPrice)
      if(this.otherPrice){
        this.active = 0
      }
      
    },
    // 获取公司账户信息
    getCompanyMsg(){
      httpAjax({
        url: "/services/company/account",
        method: "get",
      }).then((response) => {
        console.log(response)
        this.companyInfo = response.data
      })
    },
    // 获取 用户信息
    getUserMsg(){
      httpAjax({
        url: "/services/user/currentUser",
        method: "get",
      }).then((response) => {
        console.log(response)
        this.userInfo = response.data
      })

    },
    
    
    // 关闭dialog
    closeDialog () {
      this.visible = false
    },
    // 去支付
    toPay () {
      if(this.userInfo.companyStatus != 20){
        this.$message({
          message: '企业认证还未成功，请联系客服',
          type: "error",
        })
        return
      }
      if(this.userInfo.companyUserStatus != 1){
        this.$message({
          message: '还未加入公司，无法充值',
          type: "error",
        })
        return
      }
      if(!this.otherPrice && !this.active){
        this.$message({
          message: '请选择或输入充值金额',
          type: "error",
        })
        return
      }
      if(!this.checked){
        this.$message({
          message: '请勾选未斯科技充值用户条例',
          type: "error",
        })
        return
      }
      httpAjax({
        url: "/services/pay/icqrcode",
        method: "get",
        data: {
          amount: this.otherPrice ? this.otherPrice : this.active
        }
      }).then((response) => {
        if(response.success){
          this.visible = true
        } else {
          this.$message({
            message: response.msg,
            type: "error",
          })
        }
      })

      
    },
    // 选择价格
    choosePrice (e) {
      this.otherPrice = ''
      this.active = e
    },
    // 同意
    agree () {
      this.checked = !this.checked
    },
    // 去认证
    goApprove () {
      this.$router.push({ name: 'certification' })
    },
    // tab 切换
    handleClick (e) {
      console.log(e)
    },
    // 切换
    tabClick (e) {
      this.tabType = e
    },
  },
}
</script>

<style scoped lang='less'>
.balance-page {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 20px;

  .hover:hover {
    text-decoration: underline;
  }

  .desc-text {
    width: 792px;
    height: 32px;
    background: #fafcff;
    border-radius: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
    margin: 8px 0 32px 0;
    padding-left: 8px;
  }

  /deep/ .el-tabs__header {
    margin: 0;
  }

  .home-page-tab {
    /deep/ .is-active {
      color: #106ae7 !important;
    }
    /deep/ .el-tabs__active-bar {
      background: #106ae7 !important;
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
    }
    /deep/ .el-tabs__item:hover {
      font-size: 18px;
      color: #106ae7 !important;
    }
  }

  .balance-div {
    .top-div {
      margin: 24px 0 8px 0;

      .top-info {
        .top-info-div {
          background: #f5f9ff;
          border-radius: 4px;
          height: 114px;
          width: 388px;
          margin-right: 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 22px;

          .text-left {
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #858097;
            line-height: 25px;
            margin: 24px 0 8px 32px;
          }

          .weight-text {
            height: 33px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 33px;
            margin-left: 32px;
            .span-text {
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 20px;
              margin-left: 4px;
            }
          }
        }
      }
    }

    .tab-div {
      margin: 24px 0 16px 0px;

      .blue {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1170eb;
        line-height: 16px;
        border-bottom: 2px solid #1170eb;
        margin-right: 40px;
        padding-bottom: 4px;
      }

      .black {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 16px;
        margin-right: 40px;
      }
    }

    .bottom-div {
      background: #f5f9ff;
      border-radius: 4px;
      padding: 24px;

      .pay-price {
        margin-bottom: 24px;
        display: flex;
        .other-text {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          margin-bottom: 16px;
        }
        .el-input {
          width: 226px;
          height: 32px;
        }
        /deep/ .el-input__inner {
          width: 226px;
          height: 32px;
          border-radius: 0px 5px 5px 0px !important;
        }
        /deep/.el-input__inner::placeholder {
          font-size: 12px;
          color: #c5c5c5;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        /* 谷歌 */
        /deep/.el-input__inner::-webkit-input-placeholder {
          font-size: 12px;
          color: #c5c5c5;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        /* 火狐 */
        /deep/.el-input__inner:-moz-placeholder {
          font-size: 12px;
          color: #c5c5c5;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        /*ie*/
        /deep/.el-input__inner:-ms-input-placeholder {
          font-size: 12px;
          color: #c5c5c5;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        .price-box {
          min-width: 168px;
          height: 72px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid #d9d9d9;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999;
          margin-right: 48px;
          cursor: pointer;
        }
        .price-box:hover {
          border: 1px solid #1170eb;
          color: #1170eb;
        }
        .price-active {
          border: 1px solid #1170eb;
          color: #1170eb;
        }
        .price-logo {
          width: 46px;
          height: 32px;
          background: #1170eb;
          border-radius: 5px 0px 0px 5px;
          // border: 1px solid #CCCCCC;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }

      .agree-div {
        margin: 24px 0 8px 0;
        .agree-text {
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
        }
      }

      table {
        border-radius: 4px;
        border: 1px solid #e0e0e0;
      }

      th {
        width: 240px;
        height: 54px;
        background: #f6f6f6;
        border: none;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;

        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 54px;
      }

      td {
        width: 680px;
        height: 54px;
        background: #fff;
        border: none;
        border-bottom: 1px solid #e0e0e0;

        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 54px;
        text-indent: 80px;
      }
    }

    .pay-div {
      .txt {
        height: 32px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 32px;
      }
      .price {
        height: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 32px;
        margin: 0 16px 0 8px;
      }
      .pay-btn {
        width: 80px;
        height: 32px;
        background: #1170eb;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        padding: 0;
      }
      .pay-btn:hover {
        background: #7fb6f9;
      }
    }
  }
}
</style>
